export const APP_NAME = "ORDEXA";
export const SLOGAN = "Sales made smarter";
export const LOGO = "/logo.png";
export const LOGO_T = "/logo_t.png";

// mode: 'blue' | 'violet' | 'green' | 'red'
export function applyTheme(mode) {
  const el = document.documentElement;
  el.classList.remove("theme-blue", "theme-violet", "theme-green", "theme-red");
  el.classList.add(`theme-${mode}`);
}

const PLAN_THEME = { basic: "blue", pro: "violet", premium: "green" };

export function roleTheme(user, activeCompany) {
  if (!user) return "blue";
  if (user.role === "agent") return PLAN_THEME[activeCompany?.plan] || "green";
  if (user.role === "company") {
    if (user.subscription?.status === "trialing") return "red";
    return PLAN_THEME[user.subscription?.plan] || "blue";
  }
  return "blue";
}
